import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paper, useTheme, Stack, Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Navigate, useLoaderData, useLocation } from "react-router-dom-v5-compat";
import { axiosPrivate } from "../api/axios";
import { Routes } from "../Shared/components/Navigation/navigationUtils";
import { GiftCardText } from "./GiftCard-types";
import { GiftCardForm } from "./GiftCardForm";
export const GiftCard = () => {
    const theme = useTheme();
    const location = useLocation();
    const { success, redirectUrl, pageDescription } = useLoaderData();
    if (redirectUrl) {
        return _jsx(Navigate, { to: redirectUrl, replace: true });
    }
    else if (!success) {
        return (_jsx(Navigate, { to: Routes.NOT_FOUND, replace: true, state: Object.assign(Object.assign({}, location.state), { prevRoute: location.pathname }) }));
    }
    return (_jsx(Stack, Object.assign({ justifyContent: "center", alignItems: "center", my: 4 }, { children: _jsx(Paper, Object.assign({ sx: {
                width: "100%",
                padding: theme.spacing(5),
            } }, { children: _jsxs(Stack, Object.assign({ width: "100%", spacing: 2 }, { children: [_jsxs(Box, { children: [_jsx(Typography, Object.assign({ variant: "h2", color: "primary", gutterBottom: true }, { children: GiftCardText.TITLE })), _jsx(Typography, Object.assign({ gutterBottom: true }, { children: pageDescription !== null && pageDescription !== void 0 ? pageDescription : GiftCardText.DEFAULT_DESCRIPTION }))] }), _jsx(GiftCardForm, {})] })) })) })));
};
export const GiftCardLoader = () => {
    return axiosPrivate
        .get(`/React/GetGiftCardConfigurations`)
        .then((res) => {
        return res.data;
    })
        .catch((e) => {
        console.error(e);
    });
};
